import { Component, OnDestroy, OnInit } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { Subscription } from 'rxjs';
import { GepjarmuService } from '../gepjarmu.service';

/*  GÉPJÁRMŰ – Beállítások: az ügyfélkör (önálló / kapcsolt, intézményre szól), a cég beállításai
 *  (normaköltség, munkába járás, kerekítés, telephely, rendelvény-előtag, téli hónapok, norma-korrekciók) és
 *  a NAV havi üzemanyagárai (országosak – a telepítésen egyszer kell rögzíteni, értéket nem töltünk elő). */
@Component({
  selector: 'app-gj-beallitasok',
  templateUrl: './beallitasok.component.html',
  styleUrls: ['../../naplo/naplo-shared.scss', '../gepjarmu-shared.scss'],
})
export class GjBeallitasokComponent implements OnInit, OnDestroy {
  b: any = null;
  cimek: any[] = [];
  ment = false;
  readonly honapNevek = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];
  // NAV üzemanyagárak
  arEv = new Date().getFullYear();
  arEvek: number[] = [];
  arak: any = null;
  uzemanyagok: { k: string; v: string }[] = [];
  mentett = new Set<string>();
  private sub?: Subscription;

  constructor(public gj: GepjarmuService, private toast: ToastController) {}
  get u() { return this.gj.aktiv.ugyfelId; }
  get ir() { return this.gj.ir; }

  async ngOnInit() {
    await this.gj.init();
    const most = new Date().getFullYear();
    this.arEvek = [most + 1, most, most - 1, most - 2, most - 3, most - 4, most - 5];
    this.arEv = this.gj.aktiv.ev || most;
    this.sub = this.gj.aktiv$.subscribe(() => this.frissit());
    await this.arBetolt();
  }
  ngOnDestroy() { this.sub?.unsubscribe(); }

  async frissit() {
    if (!this.u) { this.b = null; return; }
    try {
      const [b, c] = await Promise.all([this.gj.get(`/beallitas/${this.u}`), this.gj.get(`/cimek/${this.u}`)]);
      this.b = { ...b, korrekciok: (b.korrekciok || []).map((k: any) => ({ ...k, alap: (b.alap?.korrekciok || []).find((a: any) => a.kod === k.kod)?.szazalek })) };
      this.cimek = c;
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült betölteni a beállításokat.'); }
  }
  get telephelyek() { return this.cimek.filter((c) => (c.aktiv && c.fajta === 'telephely') || c.id === this.b?.telephely_cim_id); }
  get egyebCimek() { return this.cimek.filter((c) => c.aktiv && c.fajta !== 'telephely' && c.id !== this.b?.telephely_cim_id); }
  teli(h: number): boolean { return (this.b?.teli_honapok || []).includes(h); }
  teliValt(h: number, v: boolean) {
    const l = new Set<number>(this.b.teli_honapok || []);
    if (v) l.add(h); else l.delete(h);
    this.b.teli_honapok = [...l].sort((a, c) => a - c);
  }
  klima(h: number): boolean { return (this.b?.klima_honapok || []).includes(h); }
  klimaValt(h: number, v: boolean) {
    const l = new Set<number>(this.b.klima_honapok || []);
    if (v) l.add(h); else l.delete(h);
    this.b.klima_honapok = [...l].sort((a, c) => a - c);
  }
  korrAlap(k: any) { k.szazalek = k.alap; }
  alapra() {
    const a = this.b.alap || {};
    Object.assign(this.b, { normakoltseg_ft_km: a.normakoltseg_ft_km, munkaba_ft_km: a.munkaba_ft_km, tizedes: a.tizedes, rendelveny_elotag: a.rendelveny_elotag,
      teli_honapok: [...(a.teli_honapok || [])], klima_honapok: [...(a.klima_honapok || [])],
      cegautoado_raforditas_szamla: '', cegautoado_kotelezettseg_szamla: '', vedett_ar: !!a.vedett_ar });
    for (const k of this.b.korrekciok) k.szazalek = k.alap;
  }
  async mentes() {
    if (this.ment) return;
    this.ment = true;
    try {
      const { alap, modositotta, modositva, ...adat } = this.b;
      await this.gj.put(`/beallitas/${this.u}`, { ...adat, korrekciok: adat.korrekciok.map((k: any) => ({ kod: k.kod, szazalek: k.szazalek })) });
      this.ok('Beállítások mentve.');
      await this.frissit();
    } catch (e: any) { this.hiba(e?.error?.error || 'Nem sikerült menteni.'); }
    finally { this.ment = false; }
  }

  /* ── NAV üzemanyagárak ── */
  navFut = false;
  /** A NAV-oldal azonnali letöltése a kiválasztott évre (backend: gepjarmu.js navArakFrissit). */
  async navLetoltes() {
    if (this.navFut) return;
    this.navFut = true;
    try {
      const r: any = await this.gj.post('/uzemanyagar/nav-letoltes', { ev: this.arEv });
      this.ok(r.beirt || r.valtozott ? `NAV-árak ${r.ev}: ${r.beirt} új, ${r.valtozott} módosult ár.` : `NAV-árak ${r.ev}: minden ár naprakész (${r.talalt} ár).`);
      await this.arBetolt();
    } catch (e: any) { this.hiba(e?.error?.error || 'A NAV árai most nem tölthetők le.'); }
    finally { this.navFut = false; }
  }
  async arBetolt() {
    try {
      this.arak = await this.gj.get(`/uzemanyagar?ev=${this.arEv}`);
      this.uzemanyagok = Object.entries(this.arak.uzemanyagok || {}).map(([k, v]) => ({ k, v: String(v) }));
      this.mentett.clear();
    } catch (e: any) { this.arak = null; this.hiba(e?.error?.error || 'Nem sikerült betölteni az üzemanyagárakat.'); }
  }
  arErtek(h: any, uz: string) { return h.arak?.[uz]?.ar ?? ''; }
  arCim(h: any, uz: string): string {
    const a = h.arak?.[uz];
    return a ? `${a.forras || ''}${a.modositotta ? ` – rögzítette: ${a.modositotta}` : ''}` : 'Nincs rögzítve';
  }
  async arMent(h: any, uz: string, ertek: string) {
    const regi = h.arak?.[uz]?.ar ?? '';
    const v = String(ertek ?? '').trim().replace(/\s/g, '').replace(',', '.');
    if (String(regi) === v) return;
    try {
      const r: any = await this.gj.put('/uzemanyagar', { ev: this.arEv, ho: h.ho, uzemanyag: uz, ar: v });
      if (r.torolve) delete h.arak[uz];
      else h.arak[uz] = { ...(h.arak[uz] || {}), ar: r.ar, modositotta: 'ön' };
      this.mentett.add(`${h.ho}|${uz}`);
    } catch (e: any) {
      this.hiba(e?.error?.error || 'Nem sikerült menteni az árat.');
      await this.arBetolt();
    }
  }
  get hianyzoHonapok(): number {
    if (!this.arak) return 0;
    const most = new Date();
    const utolso = this.arEv < most.getFullYear() ? 12 : this.arEv > most.getFullYear() ? 0 : most.getMonth() + 1;
    return this.arak.honapok.filter((h: any) => h.ho <= utolso && !['benzin', 'dizel'].every((u) => h.arak?.[u])).length;
  }

  private async ok(m: string) { (await this.toast.create({ message: m, duration: 2600, color: 'success' })).present(); }
  private async hiba(m: string) { (await this.toast.create({ message: m, duration: 5200, color: 'danger' })).present(); }
}
